import {useSelector} from 'react-redux';
import * as css from './WindowReports.css';
import {useTranslation} from 'react-i18next';
import RunningButton from '../../../components/runningButton/RunningButton';
import ReportCash from '../../../cash/reportCash/ReportCash';
import {WINDOW_HEIGHT} from '../../accountRealtime/AccountRealtime.css';

export default function WindowReports(){

    const {t} = useTranslation('package');
    const title = useSelector((s: any) => s.account.title);

    return (
        <css.reports gridArea="windowsReports" height={WINDOW_HEIGHT} variant="plain">
            <css.titleRow>
                <css.titleRowHeader>{t('title')} <RunningButton/></css.titleRowHeader>
                <css.subTitleRow>{t('subTitle',{name:title})} </css.subTitleRow>
            </css.titleRow>
            <ReportCash/>
        </css.reports>
    );
}
